export default __webpack_public_path__ + "static/media/expand-result.e7d01df1.svg";